(function () {
  document.querySelectorAll('[id^="VariantImageFilter-"]').forEach((dataScript) => {
    let config;
    try {
      config = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    const { sectionId, colorValues, initialColor } = config;
    if (!colorValues || !colorValues.length) return;

    // Dawn-style slider gallery (main-product section).
    let viewerContainer = document.getElementById(`Slider-Gallery-${sectionId}`);
    let thumbContainer = document.getElementById(`Slider-Thumbnails-${sectionId}`);
    const viewerSlider = document.getElementById(`GalleryViewer-${sectionId}`);
    const thumbSlider = document.getElementById(`GalleryThumbnails-${sectionId}`);
    let isAestetia = false;

    // Aestetia custom gallery fallback (featured-product section).
    if (!viewerContainer) {
      const galleryEl = document.getElementById(`gallery-${sectionId}`);
      if (!galleryEl) return;
      viewerContainer = galleryEl.querySelector('.aestetia-gallery__main');
      thumbContainer = galleryEl.querySelector('.aestetia-gallery__thumbs');
      isAestetia = true;
    }

    if (!viewerContainer) return;

    // data-media-alt is pre-lowercased in Liquid; colorValues are also lowercase.
    function shouldShow(alt, activeColor) {
      if (!activeColor) return true;

      // Does this image's alt contain any known color value?
      const isColorSpecific = colorValues.some((cv) => alt.includes(cv));

      // Shared/lifestyle images (no color keyword in alt) are always visible.
      if (!isColorSpecific) return true;

      // Color-specific images: visible only if they match the active color.
      return alt.includes(activeColor);
    }

    function applyFilterDawn(activeColor) {
      // Filter main viewer slides (li[data-media-id] inside Slider-Gallery-SID).
      viewerContainer.querySelectorAll('li[data-media-id]').forEach((slide) => {
        slide.style.display = shouldShow(slide.dataset.mediaAlt || '', activeColor) ? '' : 'none';
      });

      // Filter thumbnail strip items (li[data-target] inside Slider-Thumbnails-SID).
      if (thumbContainer) {
        thumbContainer.querySelectorAll('li[data-target]').forEach((thumb) => {
          thumb.style.display = shouldShow(thumb.dataset.mediaAlt || '', activeColor) ? '' : 'none';
        });
      }

      // Re-initialize slider page counts so the counter and prev/next buttons
      // reflect only the now-visible items (initPages filters by clientWidth > 0).
      if (viewerSlider && typeof viewerSlider.resetPages === 'function') {
        viewerSlider.resetPages();
      }
      if (thumbSlider && typeof thumbSlider.resetPages === 'function') {
        thumbSlider.resetPages();
      }
    }

    function applyFilterAestetia(activeColor, isInitial) {
      // Thumbnails: inline display toggle works because .aestetia-thumb has no CSS display:none.
      if (thumbContainer) {
        thumbContainer.querySelectorAll('button[data-target]').forEach((thumb) => {
          thumb.style.display = shouldShow(thumb.dataset.mediaAlt || '', activeColor) ? '' : 'none';
        });
      }

      // No active color — thumbnails already restored above, viewer needs no change.
      if (!activeColor) return;

      // Viewer: the CSS hides all frames except .is-active, so we must toggle the class.
      // display toggling has no effect here — is-active is the only gate.
      const frames = Array.from(viewerContainer.querySelectorAll('div[data-media-id]'));
      const activeFrame = frames.find((f) => f.classList.contains('is-active'));

      // Initial load: if the currently shown frame already matches, leave it alone.
      if (isInitial && activeFrame && shouldShow(activeFrame.dataset.mediaAlt || '', activeColor)) return;

      // Find the first frame whose alt matches the active color.
      const firstMatch = frames.find((f) => shouldShow(f.dataset.mediaAlt || '', activeColor));
      if (!firstMatch || firstMatch === activeFrame) return;

      // Swap is-active on viewer frames.
      if (activeFrame) activeFrame.classList.remove('is-active');
      firstMatch.classList.add('is-active');

      // Sync the is-active indicator on the corresponding thumbnail button.
      if (thumbContainer) {
        thumbContainer.querySelectorAll('button[data-target]').forEach((thumb) => {
          thumb.classList.toggle('is-active', thumb.dataset.target === firstMatch.id);
        });
      }
    }

    function applyFilter(selectedOptions, isInitial) {
      // selectedOptions is already lowercased by the caller.
      const activeColor = selectedOptions.find((opt) => colorValues.includes(opt)) || null;

      if (isAestetia) {
        applyFilterAestetia(activeColor, isInitial);
      } else {
        applyFilterDawn(activeColor);
      }
    }

    // React to variant changes fired by product-info.js after each selection.
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;
      if (!data.variant) return;

      applyFilter((data.variant.options || []).map((v) => v.toLowerCase()), false);
    });

    // Apply filtering for the variant that is already selected on page load.
    // initialColor is embedded in the Liquid JSON - no DOM query needed,
    // which avoids any timing issue with deferred script load order.
    if (initialColor) {
      applyFilter([initialColor], true);
    }
  });
})();
